import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';
import { FLAG_SVG } from '@/shared/assets/icons/flags/flag.const';

// Wraps a flag's art; the art itself stays theme-free so Modern can draw it in its own <svg>.
export const FlagIcon: React.FC<TBaseIcon> = ({ children, ...props }) => (
  <BaseIcon {...FLAG_SVG} fill="none" {...props}>
    {children}
  </BaseIcon>
);

FlagIcon.displayName = 'FlagIcon';
